import React, { Component } from "react";
import SignupForm from "../Form";
import "./styles.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class SignUpPage extends Component {
    render() {
        return (
            <div className={"signup-screen"}>
                <SignupForm />
            </div>
        );
    }
}

SignUpPage.propTypes = {
    error: PropTypes.object,
};

SignUpPage.defaultProps = {
    error: {},
};

/* istanbul ignore next */
const mapStateToProps = function (state) {
    return {
        error: state.SignupReducer.error,
    };
};

export default connect(mapStateToProps)(SignUpPage);
